<div class="iframe__container">
  <ng-container *ngIf="url && !isScullyRunning" [ngSwitch]="video?.platform">
    <iframe *ngSwitchCase="'youtube'" [src]="url" frameborder="0"></iframe>
  </ng-container>
</div>
